import { Pipe, PipeTransform } from '@angular/core';
import { Plugin } from 'src/api/models';
//import { Plugin } from 'sortablejs';

@Pipe({
  name: 'findPluginsByCategory'
})
export class FindPluginsByCategoryPipe implements PipeTransform {

  transform(plugins: Plugin[], category:string): Plugin[] | undefined {
    if (category && plugins) {
      return plugins.filter(p => p.categorys.includes(category));
    }
    return null;
  }

}
